import { ReactNode } from 'react'
import clsx from 'clsx'
import Section from './section'
import Item from './section-item'
import * as styles from './styles.module.css'
import { Col, Row } from 'components/common'

type Children = ReactNode | ReactNode[]
export interface FooterProps {
  left?: Children
  right?: Children
}

const Footer = ({ left, right }: FooterProps): JSX.Element => (
  <>
    <Section size={'large'}>
      <Item>
        <div className={clsx(styles.section__footer)}>
          <Row>
            <Col span={12}>{left}</Col>
            <Col className={'flex justify-end'} span={12}>
              {right}
            </Col>
          </Row>
        </div>
      </Item>
    </Section>

    {/* 見た目を整えるために空の DOM が必要 */}
    {/*<Section size={'small'}>*/}
    {/*  <Item />*/}
    {/*</Section>*/}
  </>
)

export default Footer
